import { render, staticRenderFns } from "./feedbackDetailIframe.vue?vue&type=template&id=55deba13&"
import script from "./feedbackDetailIframe.vue?vue&type=script&lang=js&"
export * from "./feedbackDetailIframe.vue?vue&type=script&lang=js&"
import style0 from "./feedbackDetailIframe.vue?vue&type=style&index=0&id=55deba13&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports